import React from "react";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa"; // Ícone de cadeado

const AccessDenied = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navega para a página anterior
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center p-4">
      <FaLock size={60} className="text-red-500 mb-6" />
      <h1 className="text-3xl font-semibold text-gray-800 mb-4">Acesso Negado</h1>
      <p className="text-lg text-gray-600 mb-6">
        Você não tem permissão para acessar esta página.
      </p>
      <button
        onClick={handleGoBack}
        className="px-6 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
      >
        Voltar
      </button>
    </div>
  );
};

export default AccessDenied;
